export default __webpack_public_path__ + "static/media/footer7.7c1a91c5.png";